<template>
  <div class="w-full h-full grid md:grid-cols-2">
    <WelcomeComponent class="relative  hidden md:flex" />
    <RegisterComponent class="relative" />
  </div>
</template>

<script>
import RegisterComponent from "../components/appComponent/RegisterComponent.vue";
import WelcomeComponent from "../components/appComponent/WelcomeComponent.vue";

export default {
  components: {
    WelcomeComponent,
    RegisterComponent,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
